<div style="display: flex;justify-content: center;margin-top: 40vh;">
  <div class="loader"></div>
</div>